import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classnames from "classnames";
import axios from "axios";
import SupportContainer from '../home/SupportContainer';

import {
  GET_ERRORS,
  SET_CURRENT_USER,
  USER_LOADING
} from "../../actions/types";

import $ from 'jquery';

class Forgotpassword extends Component {

  constructor() {
    super();

    this.state = {
        email:"",
        msg:"",
        showError:false,
        messageFromServer:'',
        type:"1",
        errors: {},
        show_loader:false,
		supportPageName: 'Forgot Password',
		supportPageApi: '/forgotpassword',
		userTypeFaqs: 1
      };
  }

  componentDidMount() {}

  componentWillMount(){}

  handleChange = name => e => {
    this.setState({[name]: e.target.value});
  };

  sendEmail = e => {
    e.preventDefault();

    const userData = {
      email: this.state.email
    };
  
    if(this.state.email == "")
    {
      this.setState({
        msg: 'Email can\'t be empty'
      });
    } else {
        this.setState({show_loader:true});

        axios
        .post(process.env.REACT_APP_API_URL+"/api/v1/user/forgotpassword",userData)                
        .then(res => {

            console.log('Forgot Password - ', res.data);

            this.setState({
              msg: res.data.responseData.message,
              show_loader:false
            });

        })
        .catch(err =>{
            console.log('Forgot Password error - ', err.response.data.errorData);

            this.setState({
              msg: err.response.data.errorData,
              show_loader:false
            });
        });
    }                    
  };

  cancelClick = () => {
    this.props.history.push("/login");
  };

  render() {

    const {password,errors,isLoading,updated}=this.state;

    return (

        <div className="container">
        <div className="row">
          <div className="login-bg">
            <div className="login-box">
              <div className="col-md-7 col-lg-5 col-sm-6 text-light mx-auto">
              
              <div className="col-12">
                <img src="./images/login-logo.png" className="login-logo" />
                <p className="login-tagline">Forgot Password</p>
              </div>
              <form className="form-horizontal pt-1" role = "form" noValidate onSubmit={this.sendEmail} autoComplete="off">
              
                <div className="login-inner">

                {(
                  ()=>{
                      if(this.state.msg == "Email has been sent to your email id") {
                          return  <div id="msg"  style={{color:'green'}}>{this.state.msg}</div>;
                        } else {
                            return  <div id="msg"  style={{color:'white'}}>{this.state.msg}</div>;                     
                        }
                  }
                )()}

                <div className="form-group pb-3 mb-0 mt-4"> 
                    <span className="text-danger">{errors.email}{errors.emailincorrect}</span>                       
                    <label>Enter your email address</label>
                    <input autoFocus type="email"  id="email" onChange={this.handleChange('email')} value={this.state.email} className="form-control"  />
                    <img src="./images/login-user.png" className="user-login" />
                </div>
                   
                <div className="form-group pt-3 mb-4">
                  <div className="d-flex flex-wrap align-items-center">
                    <button type = "button" className="btn-cancel btn btn-large btn-outline-secondary waves-effect waves-light hoverable blue accent-3 rounded p-3 px-4" onClick={this.cancelClick}>Cancel</button>
                    <button type = "submit" className="btn-login btn btn-large btn-primary waves-effect waves-light hoverable blue accent-3 p-3 px-4 mx-3 rounded">Submit</button> 
                    <div className={classnames({'circle':true, 'd-none':!this.state.show_loader})}></div>
                  </div>
                </div>                
              </div>
            </form> 
            </div>
            </div>
            <a href="privacy-policy.html" target="_blank" className="privacy-link">Click to view the virdio privacy policy</a>
          </div>
          
        </div>
		
		<SupportContainer supportPageName={this.state.supportPageName} supportPageApi={this.state.supportPageApi} userTypeFaqs={this.state.userTypeFaqs}></SupportContainer>
      </div>

    );
  }
}

const container = {
    "padding": "0px 15px",
    "max-width": "1140px"
  
  };

export default connect()(Forgotpassword);

